import { Component, OnInit, ViewChild } from '@angular/core';
import { CheckAuth } from 'src/Services/utility.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { FullCalendar } from 'primeng/fullcalendar/primeng-fullcalendar';
import { OverlayPanel } from 'primeng';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { TracItActionCalendarSearch, ActionItemCalendarModel, ActionItemListViewModel, DashboardCountModel, DashboardNotesModel } from 'src/Models/TracItModel';
import { ActionItemService } from 'src/Services/tracit.service';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { TracItSearchPanelComponent } from 'src/app/Shared/TracIt/search-panel/search-panel.component';
import { TracItNotesPopupComponent } from 'src/app/Shared/TracIt/notes-popup/notes-popup.component';
import { TracItActionStatusPopupComponent } from 'src/app/Shared/TracIt/action-status-popup/action-status-popup.component';
import { TracItAddNewActionPopupComponent } from 'src/app/Shared/TracIt/add-new-action-popup/add-new-action-popup.component';
import { TracItActionItemDetailsPopupComponent } from 'src/app/Shared/TracIt/action-item-details-popup/action-item-details-popup.component';
import { TracItEditActionPopupComponent } from 'src/app/Shared/TracIt/edit-action-popup/edit-action-popup.component';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-tracit-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class TracItActionItemDashboardComponent implements OnInit {
  tokenKey: string = '';
  isShowprogressSpinner: boolean;
  blockedDocument: boolean;
  loginUser: any;

  @ViewChild('ucCalendar', { static: false }) fc: FullCalendar;
  @ViewChild('search', { static: false }) search: TracItSearchPanelComponent;

  fromDate: string = '';
  toDate: string = '';
  bsRangeValue: Date[];
  CurrentTime = new Date();
  EndTime = new Date();

  dashboardCounterModel = new DashboardCountModel();
  dashboardNotesModel: DashboardNotesModel[];
  reminderList: ActionItemListViewModel[];

  isdashboardCounterDataLoad: boolean = false;
  dashboardCounterTotalRecords: number = -1;
  isdashboardNotesDataLoad: boolean = false;
  dashboardNotesTotalRecords: number = -1;
  isReminderDataLoad: boolean = false;

  isdashboardActionItemsRequiredAttentionDataLoad: boolean = false;
  dashboardActionItemsRequiredAttentionTotalRecords: number = -1;

  isdashboardUpcomingReminderDataLoad: boolean = false;
  dashboardUpcomingReminderTotalRecords: number = -1;

  ClientSelectedTool: string;
  productId: number = 1;

  parentSearchModel = new TracItActionCalendarSearch();
  listView: ActionItemListViewModel[];
  orderBy: any = '';
  isAscending: boolean = false;
  upDowDeadlineDateCSS: string = '';
  upDowStateCSS: string = '';
  upDowTypeCSS: string = '';
  upDowCategoryCSS: string = '';
  upDowStatusCSS: string = '';
  upDowNotesCSS: string = '';

  upDowReminderDeadlineDateCSS: string = 'active-up';
  upDowReminderStateCSS: string = '';
  upDowReminderCategoryCSS: string = '';
  upDowReminderStatusCSS: string = '';
  isReminderAscending: boolean = false;
  reminderorderBy: any = 'DeadlineDate';

  FilterFavourite: boolean = false;
  isMyTracIt: boolean = false;
  isListShow: boolean = false;

  options: any;
  defaultView: string = 'timeGridWeek';
  events: ActionItemCalendarModel[];

  actionId: number = 0;
  updateId: number = 0;
  headerString: string = '';
  briefingId: number = 0;
  isActionCompanySpecific: boolean = false;
  isInformativeOnly: boolean = false;
  isHoverButtonClick: boolean = false;

  isDateChange: boolean = false;
  recurranceId = 0;
  monthList = [];
  yearList = [];
  monthyearSettings = {};
  selectdMonth = [];
  selectedYear = [];
  currentYear = new Date().getFullYear();
  isClickOnDashboard: boolean = false;
  showDescription: boolean = true;

  companyId: number;
  titleSearch: string;

  tracItUnread: number = 0;
  tracItUnreadflag: boolean = true;

  private initialized = false;

  constructor(private readonly toastr: ToastrService,
    private readonly titleService: Title,
    private readonly router: Router,
    private readonly modalService: NgbModal,
    private readonly checkAuth: CheckAuth,
    private readonly actionServices: ActionItemService,
    private readonly appActivity: ApplicationActivityService,
    private sessionStorageService: SessionStorageService) {

    this.productId = ToolEnum.actionitem;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());

    this.titleService.setTitle('Dashboard | JSi360');
    this.parentSearchModel.isMyTracIt = this.isMyTracIt;
    this.titleSearch = "";
    this.ClientSelectedTool = sessionStorage.getItem('ClientLoginTool');
    this.companyId = +sessionStorage.getItem("CompanyId");
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.loginUser = sessionStorage.getItem('UserId');
    this.resetDate();
    this.loadCalanderSetting();
    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    const interval = setInterval(() => {
      this.tokenKey = this.sessionStorageService.getTokenValue();
      if (this.tokenKey) {
        clearInterval(interval);
        this.afterTokenReady();
      }
    }, 100); // check every 100ms
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    this.setSearchSetting();
    //this.GetActionItemDashboardCounts();
    this.ActionItemForReminderDashbaord();
    this.GetDashboardActionItemsReuiredAttention();
    this.GetActionUpdates();
    ApplicationActivityStore('View', 'Trac It - Providers', this.appActivity, ToolEnum.actionitem, ActionActivity['Trac It'], '/trac-it/Dashboard');

    this.tryInitAfterTokenAndView();
  }

  ngOnInit() {

  }

  onDateChange(value: any) {
    if (value) {
      this.onValueChange(value);
    }
  }

  setSearchSetting() {
    // if (sessionStorage.getItem('dashboardSettingFromDate') != '' && sessionStorage.getItem('dashboardSettingFromDate') != null &&
    //   sessionStorage.getItem('dashboardSettingToDate') != '' && sessionStorage.getItem('dashboardSettingToDate') != null) {
    //   this.fromDate = sessionStorage.getItem('dashboardSettingFromDate');
    //   this.toDate = sessionStorage.getItem('dashboardSettingToDate');
    //   let CurrentTime = new Date(this.fromDate);
    //   let EndTime = new Date(this.toDate);
    //   this.bsRangeValue = [CurrentTime, EndTime];
    // }

    this.CurrentTime = new Date();
    this.EndTime = new Date();
    this.CurrentTime.setDate(this.EndTime.getDate());
    let curr = new Date(this.CurrentTime); // get current date
    let first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    let last = first + 6;
    this.CurrentTime = new Date(curr.setDate(first)),
      this.EndTime = new Date(curr.setDate(last))

    this.fromDate = this.CurrentTime.getFullYear() + '-' + (this.CurrentTime.getMonth() + 1) + '-' + this.CurrentTime.getDate();
    this.toDate = this.EndTime.getFullYear() + '-' + (this.EndTime.getMonth() + 1) + '-' + this.EndTime.getDate();
    this.bsRangeValue = [this.CurrentTime, this.EndTime];
    this.parentSearchModel.userId = this.loginUser;
    this.parentSearchModel.dateFrom = this.fromDate;
    this.parentSearchModel.toDate = this.toDate;

    if (sessionStorage.getItem('dashboardSettingIsFavorite') == 'true' && sessionStorage.getItem('dashboardSettingIsFavorite') != null) {
      this.FilterFavourite = true;
      this.parentSearchModel.isFavorite = true;
    }

    if (sessionStorage.getItem('dashboardSettingIsMyTracIt') == 'true' && sessionStorage.getItem('dashboardSettingIsMyTracIt') != null) {
      this.isMyTracIt = true;
      this.parentSearchModel.isMyTracIt = true;
    }
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  GetActionItemDashboardCounts() {
    this.isdashboardCounterDataLoad = true;
    this.actionServices.GetActionItemDashboardCounts(this.loginUser, this.fromDate, this.toDate, this.FilterFavourite, this.isMyTracIt).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.isdashboardCounterDataLoad = false;
          this.dashboardCounterModel = data['dashboardCouter'];
          if (this.dashboardCounterModel != null) {

          }
        }
      },
      error => {
        this.isdashboardCounterDataLoad = false;
        this.unblockDocument();
      }
    );
  }

  GetActionItemDashboardNotes() {
    this.isdashboardNotesDataLoad = true;
    this.actionServices.GetActionItemDashboardNotes(this.loginUser, this.fromDate, this.toDate, this.FilterFavourite, this.isMyTracIt).subscribe(
      data => {
        this.isdashboardNotesDataLoad = false;
        if (data['status'] == 'Success') {
          this.dashboardNotesModel = data['dashboardNotes'];
          if (this.dashboardNotesModel != null) {
            this.dashboardNotesTotalRecords = this.dashboardNotesModel.length;
          }
        }
      },
      error => {
        this.isdashboardNotesDataLoad = false;
        this.unblockDocument();
      }
    );
  }

  ActionItemForReminderDashbaord() {
    this.blockDocument();
    this.reminderList = [];
    setTimeout(() => {
      this.isReminderDataLoad = true;
      this.isdashboardUpcomingReminderDataLoad = true;
      this.parentSearchModel.Search = this.titleSearch;
      this.actionServices.ActionItemForReminderDashbaord(this.reminderorderBy, this.parentSearchModel).subscribe(
        data => {
          this.unblockDocument();
          this.isReminderDataLoad = false;
          this.isdashboardUpcomingReminderDataLoad = false;
          if (data['status'] == 'Success') {
            this.reminderList = data['reminderList'];
            this.dashboardUpcomingReminderTotalRecords = this.reminderList.length;
          }
          else {
            this.dashboardUpcomingReminderTotalRecords = 0;
          }
        },
        error => {
          this.isReminderDataLoad = false;
          this.unblockDocument();
        }
      );
    }, 100);
  }


  onValueChange(value: Date): void {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    const d = new Date(value[0]);
    const a = [pad(d.getMonth() + 1), pad(d.getDate()), d.getFullYear()].join('/');

    const e = new Date(value[1]);
    const f = [pad(e.getMonth() + 1), pad(e.getDate()), e.getFullYear()].join('/');

    this.fromDate = a;
    this.toDate = f;

    this.parentSearchModel.dateFrom = this.fromDate;
    this.parentSearchModel.toDate = this.toDate;

    const timeDifference = (new Date(this.toDate)).getTime() - (new Date(this.fromDate)).getTime();
    const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
    if (daysDifference <= 120) {
      //this.GetActionItemDashboardCounts();
      this.GetDashboardActionItemsReuiredAttention();
      this.ActionItemForReminderDashbaord();
      this.saveDashboardSetting();
    }
    else {
      setTimeout(() => this.toastr.error('Please select dates in the range of four months only.', 'Error!'));
    }
  }

  resetDate() {
    this.CurrentTime = new Date();
    this.EndTime = new Date();
    this.CurrentTime.setDate(this.EndTime.getDate());
    let curr = new Date(this.CurrentTime); // get current date
    let first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    let last = first + 6;
    this.CurrentTime = new Date(curr.setDate(first)),
      this.EndTime = new Date(curr.setDate(last))

    this.fromDate = this.CurrentTime.getFullYear() + '-' + (this.CurrentTime.getMonth() + 1) + '-' + this.CurrentTime.getDate();
    this.toDate = this.EndTime.getFullYear() + '-' + (this.EndTime.getMonth() + 1) + '-' + this.EndTime.getDate();
    this.bsRangeValue = [this.CurrentTime, this.EndTime];
    this.parentSearchModel.userId = this.loginUser;
    this.parentSearchModel.dateFrom = this.fromDate;
    this.parentSearchModel.toDate = this.toDate;
  }

  clearDate() {
    this.CurrentTime = new Date();
    this.EndTime = new Date();
    this.CurrentTime.setDate(this.EndTime.getDate());
    let curr = new Date(this.CurrentTime); // get current date
    let first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    let last = first + 6;
    this.CurrentTime = new Date(curr.setDate(first)),
      this.EndTime = new Date(curr.setDate(last))

    this.fromDate = this.CurrentTime.getFullYear() + '-' + (this.CurrentTime.getMonth() + 1) + '-' + this.CurrentTime.getDate();
    this.toDate = this.EndTime.getFullYear() + '-' + (this.EndTime.getMonth() + 1) + '-' + this.EndTime.getDate();
    this.bsRangeValue = [this.CurrentTime, this.EndTime];
    this.parentSearchModel.userId = this.loginUser;
    this.parentSearchModel.dateFrom = this.fromDate;
    this.parentSearchModel.toDate = this.toDate;

    this.GetActionItemDashboardCounts();
    this.GetDashboardActionItemsReuiredAttention();
    this.ActionItemForReminderDashbaord();
    this.saveDashboardSetting();
  }

  OpenNotesPopup(actionId: any, updateId: any, briefingId: any) {
    sessionStorage.setItem('productId', this.productId.toString());
    sessionStorage.setItem('actionId', actionId);
    sessionStorage.setItem('updateId', updateId);
    sessionStorage.setItem('briefingId', briefingId);
    const modalRef = this.modalService.open(TracItNotesPopupComponent, { size: 'lg', windowClass: 'note-modal-window' }).result.then(
      result => {
        this.GetDashboardActionItemsReuiredAttention();
        this.ActionItemForReminderDashbaord();
      },
      reason => {
        this.isHoverButtonClick = false;
      });
  }

  GetDashboardActionItemsReuiredAttention() {
    this.isdashboardActionItemsRequiredAttentionDataLoad = true;
    this.listView = [];
    this.parentSearchModel.Search = this.titleSearch;
    this.actionServices.GetDashboardActionItemsReuiredAttention(this.orderBy, this.parentSearchModel).subscribe(
      data => {
        this.isdashboardActionItemsRequiredAttentionDataLoad = false;
        this.unblockDocument();
        this.listView = data['listView'];
        if (this.listView != null) {
          this.dashboardActionItemsRequiredAttentionTotalRecords = this.listView.length;
        }
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  setClass(status) {
    if (status === 'Acknowledged') {
      return 'btn label label-primary  ack_message';
    } else if (status === 'Done') {
      return 'btn label label-success  done_message';
    } else if (status === 'Pending') {
      return 'btn label label-danger  btn_pendding';
    } else {
      return 'btn label label-default ign_message';
    }
  }

  sort(sortBy: string) {
    this.upDowDeadlineDateCSS = '';
    this.upDowStateCSS = '';
    this.upDowTypeCSS = '';
    this.upDowCategoryCSS = '';
    this.upDowStatusCSS = '';
    this.upDowNotesCSS = '';
    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "DeadlineDate") {
        this.upDowDeadlineDateCSS = 'active';
      }
      else if (sortBy === "State") {
        this.upDowStateCSS = 'active';
      }
      else if (sortBy === "Type") {
        this.upDowTypeCSS = 'active';
      }
      else if (sortBy === "Category") {
        this.upDowCategoryCSS = 'active';
      }
      else if (sortBy === "Status") {
        this.upDowStatusCSS = 'active';
      }
      else if (sortBy === "Notes") {
        this.upDowNotesCSS = 'active';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "DeadlineDate") {
        this.upDowDeadlineDateCSS = 'active-up';
      }
      else if (sortBy === "State") {
        this.upDowStateCSS = 'active-up';
      }
      else if (sortBy === "Type") {
        this.upDowTypeCSS = 'active-up';
      }
      else if (sortBy === "Category") {
        this.upDowCategoryCSS = 'active-up';
      }
      else if (sortBy === "Status") {
        this.upDowStatusCSS = 'active-up';
      }
      else if (sortBy === "Notes") {
        this.upDowNotesCSS = 'active-up';
      }
    }
    this.GetDashboardActionItemsReuiredAttention();
    this.ActionItemForReminderDashbaord();
  }

  OpenActionStatusPopup(actionId: any, updateId: any, isInformationOnly: boolean, briefingId: any) {
    sessionStorage.setItem('productId', this.productId.toString());
    sessionStorage.setItem('actionId', actionId);
    sessionStorage.setItem('updateId', updateId);
    sessionStorage.setItem('briefingId', briefingId);
    if (isInformationOnly) {
      this.OpenNotesPopup(actionId, updateId, briefingId);
    }
    else {
      const modalRef = this.modalService.open(TracItActionStatusPopupComponent, { size: 'lg', windowClass: 'actionstatus-modal-window' }).result.then(
        result => {

          if (result == 'Yes' || result == 'Reload') {
            this.GetDashboardActionItemsReuiredAttention();
            this.ActionItemForReminderDashbaord();
          }
        },
        reason => {
        });
    }
  }

  openAddNewActionItemPopup() {
    sessionStorage.setItem('productId', this.productId.toString());
    const modalRef = this.modalService.open(TracItAddNewActionPopupComponent, { size: 'lg', windowClass: "AddNewActionPopup" }).result.then(
      result => {
        if (result == 'Yes') {
          this.GetDashboardActionItemsReuiredAttention();
        }
      },
      reason => {

      });
  }

  redirectToActionItemList(listId: any, type: any) {
    if (this.checkDayIs120()) {
      sessionStorage.setItem('isClickOnDashboard', 'true');
      sessionStorage.setItem('dashboardFromDate', this.fromDate);
      sessionStorage.setItem('dashboardToDate', this.toDate);
      sessionStorage.setItem('dashboardIsFavorite', this.FilterFavourite.toString());
      sessionStorage.setItem('dashboardIsMyTracIt', this.isMyTracIt.toString());

      this.saveDashboardSetting();

      if (type == 'actionType') {
        sessionStorage.setItem('dashboardSummaryType', listId);
      }
      else if (type == 'carrier') {
        sessionStorage.setItem('dashboardCarrierCategories', listId);
      }
      else if (type == 'actionStatus') {
        sessionStorage.setItem('dashboardActionStatus', listId);
      }
      this.router.navigate(['/trac-it/Calendar']);
    }
  }

  loadMyFavourite() {
    this.FilterFavourite = !this.FilterFavourite;
    this.parentSearchModel.isFavorite = this.FilterFavourite;
    //this.GetActionItemDashboardCounts();
    this.GetDashboardActionItemsReuiredAttention();
    this.saveDashboardSetting();
    this.ActionItemForReminderDashbaord();
  }

  loadMyTracIt() {
    this.isMyTracIt = !this.isMyTracIt;
    this.parentSearchModel.isMyTracIt = this.isMyTracIt;
    //this.GetActionItemDashboardCounts();
    this.GetDashboardActionItemsReuiredAttention();
    this.saveDashboardSetting();
    this.ActionItemForReminderDashbaord();
  }

  saveDashboardSetting() {

    sessionStorage.setItem('dashboardSettingFromDate', this.fromDate);
    sessionStorage.setItem('dashboardSettingToDate', this.toDate);
    sessionStorage.setItem('dashboardSettingIsFavorite', this.FilterFavourite.toString());
    sessionStorage.setItem('dashboardSettingIsMyTracIt', this.isMyTracIt.toString());
  }

  checkDayIs120() {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    const d = new Date(this.parentSearchModel.dateFrom);
    const a = [pad(d.getMonth() + 1), pad(d.getDate()), d.getFullYear()].join('/');

    const e = new Date(this.parentSearchModel.toDate);
    const f = [pad(e.getMonth() + 1), pad(e.getDate()), e.getFullYear()].join('/');

    this.fromDate = a;
    this.toDate = f;

    this.parentSearchModel.dateFrom = this.fromDate;
    this.parentSearchModel.toDate = this.toDate;

    const timeDifference = (new Date(this.toDate)).getTime() - (new Date(this.fromDate)).getTime();
    const daysDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
    if (daysDifference <= 120) {
      return true;
    }
    else {
      setTimeout(() => this.toastr.error('Please select dates in the range of four months only.', 'Error!'));
      return false;
    }
  }

  reminderSort(sortBy: string) {
    this.upDowReminderDeadlineDateCSS = '';
    this.upDowReminderCategoryCSS = '';
    this.upDowReminderStateCSS = '';
    this.upDowReminderStatusCSS = '';

    if (!this.isReminderAscending) {
      this.isReminderAscending = true;
      this.reminderorderBy = sortBy + ' DESC';
      if (sortBy === "DeadlineDate") {
        this.upDowReminderDeadlineDateCSS = 'active';
      }
      else if (sortBy === "State") {
        this.upDowReminderStateCSS = 'active';
      }
      else if (sortBy === "Category") {
        this.upDowReminderCategoryCSS = 'active';
      }
      else if (sortBy === "Status") {
        this.upDowReminderStatusCSS = 'active';
      }
    }
    else {
      this.isReminderAscending = false;
      this.reminderorderBy = sortBy;
      if (sortBy === "DeadlineDate") {
        this.upDowReminderDeadlineDateCSS = 'active-up';
      }
      else if (sortBy === "State") {
        this.upDowReminderStateCSS = 'active-up';
      }
      else if (sortBy === "Category") {
        this.upDowReminderCategoryCSS = 'active-up';
      }
      else if (sortBy === "Status") {
        this.upDowReminderStatusCSS = 'active-up';
      }
    }
    this.ActionItemForReminderDashbaord();
  }

  private isViewInitialized = false;

  private initViewDependentLogic(): void {
    setTimeout(() => {
      this.setDefaultDate();
      this.bindEvents();
      this.loadWeekData(); // SINGLE SOURCE
    });
  }

  ngAfterViewInit() {
    this.isViewInitialized = true;
    this.tryInitAfterTokenAndView();
  }

  private tryInitAfterTokenAndView(): void {
    if (this.tokenKey && this.isViewInitialized && !this.initialized) {
      this.initialized = true;
      this.initViewDependentLogic();
    }
  }


  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  loadCalanderSetting() {
    this.options = {
      editable: false,
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      defaultView: this.defaultView,
      displayEventTime: false,
      displayEventEnd: false,
      minTime: '00:00:00',
      maxTime: '00:00:00',
      views: {
        dayGrid: {
          eventLimit: 4
        }
      },
      header: {
        left: 'prev,next, today',
        right: 'timeGridWeek'
      },
      buttonText:
      {
        today: 'Today',
        month: 'Month',
        week: 'Week',
        list: 'List'
      },
      customButtons: {
        customList: {
          text: "List",
          click: r => {
            this.defaultView = 'customList'
            this.unBindEvents();
            this.search.showHideCalendar(true);
            this.listView = [];
            this.set120Day();
            this.isListShow = true;
            this.sort("DeadlineDate");
          }
        },
      },
      eventRender: function (event, element, view) {

      },
      eventAfterRender: function (event, element, view) {

      }
    };
  }

  showCalander(defaultView: any) {
    this.fc.calendar.changeView(defaultView);
    if (defaultView == 'timeGridWeek') {
      this.loadWeekData();
    }

    this.defaultView = defaultView;
    this.isListShow = false;
    this.search.showHideCalendar(false);
  }

  loadWeekData() {

    const d = new Date(this.fc.calendar.view.currentStart);
    const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');

    const e = new Date(this.fc.calendar.view.currentEnd);
    const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

    this.parentSearchModel.dateFrom = a;
    this.parentSearchModel.toDate = f;
    this.parentSearchModel.productId = this.productId;
    this.GetCalendarData(this.parentSearchModel);
  }

  unBindEvents() {
    const prevButton = this.fc.el.nativeElement.getElementsByClassName('fc-prev-button');
    const nextButton = this.fc.el.nativeElement.getElementsByClassName('fc-next-button');
    const todayButton = this.fc.el.nativeElement.getElementsByClassName('fc-today-button');
    const monthButton = this.fc.el.nativeElement.getElementsByClassName('fc-dayGridMonth-button');
    const weekButton = this.fc.el.nativeElement.getElementsByClassName('fc-timeGridWeek-button');

    prevButton[0].removeEventListener('click', () => {
    });
    nextButton[0].removeEventListener('click', () => {
    });
    todayButton[0].removeEventListener('click', () => {
    });
    monthButton[0].removeEventListener('click', () => {
    });
    weekButton[0].removeEventListener('click', () => {
    });
  }

  set120Day() {
    let CurrentTime = new Date(this.fc.calendar.view.currentStart);

    var firstDay = new Date(CurrentTime.getFullYear(), CurrentTime.getMonth(), 1);

    firstDay.setDate(firstDay.getDate() - 30);

    var lastDay = new Date(CurrentTime.getFullYear(), CurrentTime.getMonth(), this.daysInMonth(CurrentTime.getMonth() + 1,
      CurrentTime.getFullYear()));

    lastDay.setDate(lastDay.getDate() + 60);

    const dd = new Date(firstDay);
    const aa = [this.pad(dd.getMonth() + 1), this.pad(dd.getDate()), dd.getFullYear()].join('/');

    const ee = new Date(lastDay);
    const ff = [this.pad(ee.getMonth() + 1), this.pad(ee.getDate()), ee.getFullYear()].join('/');

    this.parentSearchModel.dateFrom = aa;
    this.parentSearchModel.toDate = ff;
  }

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  eventClick(event: any) {

    if (event.target.className == "fc-title" || event.target.className == "fc-content") {
      let parentOffset = event.target.offsetParent;
      if (event.target.className == "fc-title") {
        parentOffset = event.target.offsetParent.offsetParent;
      }
      if (parentOffset) {
        const classes = parentOffset.className.split(' ');
        if (classes.length > 0) {
          classes.forEach((element, i) => {
            if (element.includes('event-format_')) {
              this.actionId = element.split('_')[1];
              this.updateId = element.split('_')[2];
              let companySpecific = element.split('_')[3];
              let isInformativeOnly = element.split('_')[4];
              this.briefingId = element.split('_')[5];
              if (companySpecific > 0)
                this.isActionCompanySpecific = true;
              else
                this.isActionCompanySpecific = false;

              if (isInformativeOnly > 0) {
                this.isInformativeOnly = true;
                this.OpenNoteHoverPopup();
              }
              else {
                this.isInformativeOnly = false;
                this.OpenStatusHoverPopup()
              }

            }
          });
        }
      }
    }
  }

  GetCalendarData(searchModel: TracItActionCalendarSearch) {
    this.blockDocument();
    searchModel.Search = this.titleSearch;

    this.actionServices.getDashboardCalendarData(searchModel).subscribe(
      data => {
        this.unblockDocument();
        this.events = data['actionItem'];
        searchModel.toDate = this.parentSearchModel.toDate;
        searchModel.dateFrom = this.parentSearchModel.dateFrom;
      },
      error => {
        this.unblockDocument();
      }
    );
  }

  GetListViewData() {
    this.listView = [];
    this.blockDocument();
    this.parentSearchModel.Search = this.titleSearch;
    this.actionServices.getListViewData(this.orderBy, this.parentSearchModel).subscribe(
      data => {
        this.unblockDocument();
        this.isDateChange = false;
        this.listView = data['listView'];
        if (this.listView != null) {
          if (this.listView.length > 0) {
          }
        }
        this.search.showHideCalendar(true);
        this.headerString = '';
        if (this.parentSearchModel != null) {
          if (this.parentSearchModel.toDate != '' && this.parentSearchModel.toDate != null && this.parentSearchModel.dateFrom != '' && this.parentSearchModel.dateFrom != null) {
            if (this.parentSearchModel.emailDeadlineDate != '' && this.parentSearchModel.emailDeadlineDate != null) {
              let sDate = new Date(this.parentSearchModel.emailDeadlineDate);
              let eDate = new Date(this.parentSearchModel.emailDeadlineDate);

              const start = [this.pad(sDate.getMonth() + 1), this.pad(sDate.getDate()), sDate.getFullYear()].join('/');
              const end = [this.pad(eDate.getMonth() + 1), this.pad(eDate.getDate()), eDate.getFullYear()].join('/');
              this.headerString = "Calendar Items From " + start + " To " + end;
            }
            else {
              let sDate = new Date(this.parentSearchModel.dateFrom);
              let eDate = new Date(this.parentSearchModel.toDate);

              const start = [this.pad(sDate.getMonth() + 1), this.pad(sDate.getDate()), sDate.getFullYear()].join('/');
              const end = [this.pad(eDate.getMonth() + 1), this.pad(eDate.getDate()), eDate.getFullYear()].join('/');
              this.headerString = "Calendar Items From " + start + " To " + end;
            }
          }
        }


      },
      error => {
        this.listView = [];
        this.unblockDocument();
      }
    );
  }

  hideWeekViewTimeLine() {
    try {
      const timeViewDiv = this.fc.el.nativeElement.getElementsByClassName('fc-time-grid-container');
      if (timeViewDiv.length > 0) {
        timeViewDiv[0].style = "display:none";
      }
    } catch (error) {
    }
  }

  selectCar(event, overlaypanel: OverlayPanel) {
    overlaypanel.toggle(event);
  }

  parentFun(searchModel: TracItActionCalendarSearch) {

    this.parentSearchModel.actionTypeIds = searchModel.actionTypeIds;
    this.parentSearchModel.carrierCatIds = searchModel.carrierCatIds;
    this.parentSearchModel.isNeworChanged = searchModel.isNeworChanged;
    this.parentSearchModel.stateIds = searchModel.stateIds;
    this.parentSearchModel.statusIds = searchModel.statusIds;
    this.parentSearchModel.userId = searchModel.userId;
    this.parentSearchModel.emailDeadlineDate = searchModel.emailDeadlineDate;
    this.parentSearchModel.isFavorite = searchModel.isFavorite;
    this.parentSearchModel.isMyTracIt = searchModel.isMyTracIt;
    this.parentSearchModel.companySpecificIds = searchModel.companySpecificIds;
    if (this.defaultView === 'dayGridMonth' || this.defaultView === 'timeGridWeek') {
      if (this.fc != null && this.fc != undefined && !this.isClickOnDashboard) {
        const d = new Date(this.fc.calendar.view.activeStart);
        const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');

        const e = new Date(this.fc.calendar.view.activeEnd);
        const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

        searchModel.toDate = f;
        searchModel.dateFrom = a;

        this.set120Day();
      }
    }
    else {

      if (searchModel.toDate && searchModel.dateFrom) {
        if (searchModel.toDate != undefined && searchModel.dateFrom != undefined) {
          this.parentSearchModel.dateFrom = searchModel.dateFrom;
          this.parentSearchModel.toDate = searchModel.toDate;
        }
      }
      else {
        searchModel.dateFrom = this.parentSearchModel.dateFrom;;
        searchModel.toDate = this.parentSearchModel.toDate;
      }
    }

    if (!this.isListShow) {
      this.GetCalendarData(searchModel);
    } else {
      this.GetListViewData();
    }
  }

  showdescription($event) {
    this.showDescription = $event.srcElement.checked;
  }

  setDefaultDate() {
    if (this.fc != null && this.fc != undefined && !this.isClickOnDashboard) {
      const d = new Date(this.fc.calendar.view.currentStart);
      const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');

      const e = new Date(this.fc.calendar.view.currentEnd);
      const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

      this.parentSearchModel.dateFrom = a;
      this.parentSearchModel.toDate = f;
    }
  }

  private onNextClick = () => this.handleCalendarNav();
  private onPrevClick = () => this.handleCalendarNav();
  private onTodayClick = () => this.handleCalendarNav();

  bindEvents() {
    const prev = this.fc.el.nativeElement.getElementsByClassName('fc-prev-button')[0];
    const next = this.fc.el.nativeElement.getElementsByClassName('fc-next-button')[0];
    const today = this.fc.el.nativeElement.getElementsByClassName('fc-today-button')[0];

    prev.removeEventListener('click', this.onPrevClick);
    next.removeEventListener('click', this.onNextClick);
    today.removeEventListener('click', this.onTodayClick);

    prev.addEventListener('click', this.onPrevClick);
    next.addEventListener('click', this.onNextClick);
    today.addEventListener('click', this.onTodayClick);
  }

  private handleCalendarNav(): void {
    const d = new Date(this.fc.calendar.view.activeStart);
    const e = new Date(this.fc.calendar.view.activeEnd - 1);

    this.parentSearchModel.dateFrom = `${d.getFullYear()}-${this.pad(d.getMonth() + 1)}-${this.pad(d.getDate())}`;
    this.parentSearchModel.toDate = `${e.getFullYear()}-${this.pad(e.getMonth() + 1)}-${this.pad(e.getDate())}`;

    this.bsRangeValue = [d, e];
    this.set120Day();
    this.GetCalendarData(this.parentSearchModel);
    this.setCurrentMonthAndYear();
  }

  // bindEvents() {

  //   const prevButton = this.fc.el.nativeElement.getElementsByClassName('fc-prev-button');
  //   const nextButton = this.fc.el.nativeElement.getElementsByClassName('fc-next-button');
  //   const todayButton = this.fc.el.nativeElement.getElementsByClassName('fc-today-button');
  //   const monthButton = this.fc.el.nativeElement.getElementsByClassName('fc-dayGridMonth-button');
  //   const weekButton = this.fc.el.nativeElement.getElementsByClassName('fc-timeGridWeek-button');

  //   nextButton[0].addEventListener('click', () => {
  //     const d = new Date(this.fc.calendar.view.activeStart);
  //     const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');
  //     const e = new Date(this.fc.calendar.view.activeEnd - 1);
  //     const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

  //     this.parentSearchModel.dateFrom = a;
  //     this.parentSearchModel.toDate = f;
  //     this.bsRangeValue = [d, e];
  //     this.set120Day();
  //     this.GetCalendarData(this.parentSearchModel);
  //     this.setCurrentMonthAndYear();
  //   });

  //   prevButton[0].addEventListener('click', () => {
  //     const d = new Date(this.fc.calendar.view.activeStart);
  //     const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');
  //     const e = new Date(this.fc.calendar.view.activeEnd - 1);
  //     const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

  //     this.parentSearchModel.dateFrom = a;
  //     this.parentSearchModel.toDate = f;
  //     this.bsRangeValue = [d, e];
  //     this.set120Day();
  //     this.GetCalendarData(this.parentSearchModel);
  //     this.setCurrentMonthAndYear();
  //   });

  //   todayButton[0].addEventListener('click', () => {

  //     const d = new Date(this.fc.calendar.view.currentStart);
  //     const a = [d.getFullYear(), this.pad(d.getMonth() + 1), this.pad(d.getDate())].join('-');

  //     const e = new Date(this.fc.calendar.view.currentEnd - 1);
  //     const f = [e.getFullYear(), this.pad(e.getMonth() + 1), this.pad(e.getDate())].join('-');

  //     this.parentSearchModel.dateFrom = a;
  //     this.parentSearchModel.toDate = f;
  //     this.bsRangeValue = [d, e];
  //     this.set120Day();
  //     this.GetCalendarData(this.parentSearchModel);
  //     this.setCurrentMonthAndYear();
  //   });

  //   weekButton[0].addEventListener('click', () => {
  //     this.set120Day();
  //     this.loadWeekData();
  //   });

  //   //this.loadWeekData();
  // }

  loadMonthData() {
    this.GetCalendarData(this.parentSearchModel);
  }

  OpenDetailPopup(actionId: any, updateId: any, briefingId: any) {
    sessionStorage.setItem('productId', this.productId.toString());
    sessionStorage.setItem('actionId', actionId);
    sessionStorage.setItem('updateId', updateId);
    sessionStorage.setItem('briefingId', briefingId);
    const modalRef = this.modalService.open(TracItActionItemDetailsPopupComponent, { size: 'lg', windowClass: 'ActionItemDetailsPopup-modal-window' }).result.then(
      result => {
        if (result == 'Yes') {
          this.isHoverButtonClick = false;
        }
        if (result == 'Reload') {
          if (this.isHoverButtonClick)
            this.GetCalendarData(this.parentSearchModel);
          this.isHoverButtonClick = false;
        }
      },
      reason => {
        this.isHoverButtonClick = false;
      });
  }

  OpenDetailHoverPopup() {
    this.OpenDetailPopup(this.actionId, this.updateId, this.briefingId)
  }

  OpenStatusHoverPopup() {
    this.OpenActionStatusPopup(this.actionId, this.updateId, false, this.briefingId)
  }

  OpenNoteHoverPopup() {
    this.isHoverButtonClick = true;
    this.OpenNotesPopup(this.actionId, this.updateId, this.briefingId)
  }

  OpenAddNewActionItemHoverPopup() {
    this.isHoverButtonClick = true;
    this.openAddNewActionItemPopup();
  }

  DeleteActionItem(deletedId, recurranceId, type) {
    const delId = type == 1 ? deletedId : 0;
    const recId = type == 2 ? recurranceId : 0;
    this.actionServices.DeleteAction(delId, recId, this.loginUser).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.showMessage('Record deleted successfully.', 'Success', 'success');
          if (this.isHoverButtonClick)
            this.GetCalendarData(this.parentSearchModel);

          this.GetListViewData();
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  editAction(actionId) {
    sessionStorage.setItem('EditActionId', actionId);
    sessionStorage.setItem('productId', this.productId.toString());

    const modalRef = this.modalService.open(TracItEditActionPopupComponent, { size: 'lg', windowClass: "EditActionPopup" }).result.then(
      result => {
        if (result == 'Yes') {
          if (this.isHoverButtonClick)
            this.GetCalendarData(this.parentSearchModel);

          this.GetListViewData();
          this.isHoverButtonClick = false;
        }
      },
      reason => {
        this.isHoverButtonClick = false;
      });
  }

  OpenEditHoverPopup() {
    this.isHoverButtonClick = true;
    this.editAction(this.actionId)
  }

  OpenDeleteHoverPopup(actionId, recurranceId) {
    this.isHoverButtonClick = true;
  }

  showListPopupHover($event, actionItemTypeId, actionId) {
    this.isHoverButtonClick = false;
    if (actionItemTypeId == 5) {
      this.actionId = actionId;
      this.OpenEditHoverPopup()
    }
  }

  fillMonths() {
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    for (let index = 0; index < 12; index++) {
      const date = new Date();
      this.monthList.push({ id: index, itemName: monthNames[index] })
      if (date.getMonth() == index)
        this.selectdMonth.push({ id: index, itemName: monthNames[index] });
    }
  }
  fillYear() {
    const date = new Date();
    var year = 2019;
    for (let index = 0; year <= date.getFullYear() + 5; index++) {
      this.yearList.push({ id: year, itemName: year })

      if (date.getFullYear() == year) {
        this.selectedYear.push({ id: year, itemName: year });
      }
      year = year + 1;
    }
  }

  onMonthChange(event) {
    if (event) {
      let monthId = 1;
      if (Array.isArray(event) && event.length == 0) {
        monthId = new Date().getMonth() + 1;
        this.selectdMonth = this.monthList.filter(x => x.id == monthId - 1);
      }
      else {
        monthId = event.id + 1;
        if (this.selectdMonth.length == 0)
          this.selectdMonth = this.monthList.filter(x => x.id == monthId - 1);
      }
      const d = new Date(this.fc.calendar.view.activeStart);
      const a = [d.getFullYear(), this.pad(monthId), '01'].join('-');
      const e = new Date(this.fc.calendar.view.activeEnd);
      const f = [e.getFullYear(), this.pad(monthId), this.pad(new Date(e.getFullYear(), monthId, 0).getDate())].join('-');
      this.parentSearchModel.dateFrom = a;
      this.parentSearchModel.toDate = f;
      this.fc.getCalendar().gotoDate(a);
      this.set120Day();
      this.GetCalendarData(this.parentSearchModel);
    }
  }

  onChangeYear(event) {
    this.currentYear = +event.itemName;
    const year = this.currentYear;
    const d = new Date(this.fc.calendar.view.currentStart);
    const a = [year, this.pad(d.getMonth() + 1), '01'].join('-');
    const e = new Date(this.fc.calendar.view.currentEnd);
    const f = [year, this.pad(e.getMonth() + 1), this.pad(new Date(year, e.getMonth(), 0).getDate())].join('-');
    this.parentSearchModel.dateFrom = a;
    this.parentSearchModel.toDate = f;
    this.fc.getCalendar().gotoDate(a);
    this.set120Day();
    this.GetCalendarData(this.parentSearchModel);
  }

  setCurrentMonthAndYear(currentDate = false) {
    const d = currentDate ? new Date() : new Date(this.fc.calendar.view.currentStart);
    this.selectdMonth = this.monthList.filter(x => x.id == d.getMonth());
    this.currentYear = d.getFullYear();
    this.selectedYear = [];
    this.selectedYear.push({ id: this.currentYear, itemName: this.currentYear });
  }

  FilterClear() {
    this.titleSearch = "";
    this.GetCalendarData(this.parentSearchModel);
    this.ActionItemForReminderDashbaord();
    this.GetDashboardActionItemsReuiredAttention();
  }


  inputFilters() {
    this.GetCalendarData(this.parentSearchModel);
    this.ActionItemForReminderDashbaord();
    this.GetDashboardActionItemsReuiredAttention();
  }

  GetActionUpdates(): void {
    this.tracItUnread = 0;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.actionServices.GetActionItemSearchListForUpdateCount(this.loginUser).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.tracItUnread = data["unreadReacord"];
          sessionStorage.setItem('tracItUnread', this.tracItUnread.toString());
          if (this.tracItUnread > 0) {
            sessionStorage.setItem('tracItUnreadflag', 'false');
            this.tracItUnreadflag = false;
          }
        }
      },
      error => {
        this.tracItUnread = 0;
      },
    );
  }
}
